import { createActions } from "reduxsauce";

const { Types, Creators } = createActions({
  consultarCargaPantallas: ["payload"],
  consultarCargaPantallasLoading: null,
  consultarCargaPantallasSuccess: ["consultarCargaPantallasData"],
  consultarCargaPantallasFailure: ["consultarCargaPantallasError"],
});

export { Types };

export default Creators;

